import { DEBUG } from '@glimmer/env';
import { singularize } from 'ember-inflector';
import { BRAND_SYMBOL } from '../ts-interfaces/utils/brand';
import normalizeModelName from './normalize-model-name';
/**
  @module @ember-data/store
*/

export function typeForRelationshipMeta(meta) {
  var modelName;
  modelName = meta.type || meta.key;
  modelName = normalizeModelName(modelName);
  if (meta.kind === 'hasMany') {
    modelName = singularize(modelName);
  }
  return modelName;
}
function shouldFindInverse(relationshipMeta) {
  var options = relationshipMeta.options;
  return !(options && options.inverse === null);
}
export class RelationshipDefinition {
  constructor(meta) {
    this.meta = meta;
    this[BRAND_SYMBOL] = void 0;
    this._type = '';
    this.__inverseKey = '';
    this.__inverseIsAsync = true;
    this.__hasCalculatedInverse = false;
    this.parentModelName = void 0;
    this.inverse = void 0;
    this.inverseIsAsync = void 0;
    this.parentModelName = meta.parentModelName;
  }
  get key() {
    return this.meta.key;
  }
  get kind() {
    return this.meta.kind;
  }
  get type() {
    if (this._type) {
      return this._type;
    }
    this._type = typeForRelationshipMeta(this.meta);
    return this._type;
  }
  get options() {
    return this.meta.options;
  }
  get name() {
    return this.meta.name;
  }
  _inverseKey(store, modelClass) {
    if (this.__hasCalculatedInverse === false) {
      this._calculateInverse(store, modelClass);
    }
    return this.__inverseKey;
  }
  _inverseIsAsync(store, modelClass) {
    if (this.__hasCalculatedInverse === false) {
      this._calculateInverse(store, modelClass);
    }
    return this.__inverseIsAsync;
  }
  _calculateInverse(store, modelClass) {
    this.__hasCalculatedInverse = true;
    var inverseKey, inverseIsAsync;
    var inverse = null;
    if (shouldFindInverse(this.meta)) {
      inverse = modelClass.inverseFor(this.key, store);
    } else if (DEBUG) {
      modelClass.typeForRelationship(this.key, store);
    }
    if (inverse) {
      inverseKey = inverse.name;
      inverseIsAsync = isInverseAsync(inverse);
    } else {
      inverseKey = null;
      inverseIsAsync = false;
    }
    this.__inverseKey = inverseKey;
    this.__inverseIsAsync = inverseIsAsync;
  }
}
function isInverseAsync(meta) {
  var inverseAsync = meta.options && meta.options.async;
  return typeof inverseAsync === 'undefined' ? true : inverseAsync;
}
export function relationshipFromMeta(meta) {
  return new RelationshipDefinition(meta);
}